<template>
    <div>

        <div class="panel panel-info" v-if="contratos.length">
            <div class="panel-heading">
                <i class="fa fa-toggle-off" aria-hidden="true"></i> CLIENTES OFFLINE
            </div>
            <div class="panel-body" >

                <table id="mytable" class="table table-bordred table-striped">

                    <thead>
                        <tr>
                            <th>CLIENTE</th>
                            <th style="text-align: center;width: 120px">IP DO CLIENTE</th>
                            <th style="text-align: center;width: 150px">ÚLTIMO PING ONLINE</th>
                            <th style="text-align: center;width: 90px">AÇÔES</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr v-for="r in contratos" v-bind:key="r._id">
                            <td>{{ r.cliente.nome }}</td>
                            <td style="text-align: center">{{ r.radio.ssh.host }}</td>
                            <td style="text-align: center">{{ r.last_ping_on | date('DD/MM/YYYY HH:mm:ss') }}</td>
                            <td style="text-align: center">
                                <a :href="'#/contrato/add/' + r._id" class="btn btn-info btn-xs">
                                    ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="4">
                                <b>{{contratos.length}} Clientes Offline</b>
                            </td>
                        </tr>

                    </tbody>

                </table>

            </div>

        </div>

        <div class="page-header" v-if="!contratos.length">
            <h1 style="color: darkblue">
                <i class="fa fa-child" aria-hidden="true"></i>
                <i class="fa fa-sign-language" aria-hidden="true"></i>
                Boas Notícias! <small>Nenhum cliente offline no momento.</small></h1>
        </div>

    </div>
</template>
<script>
import { Contratos } from "../../class/contratos";
import { date } from "../../filters";

export default {
    filters: {
        date
    },
    data() {
        return {
            contratos: [],
            user: null,
            interval: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.$parent.$on("comandos", () => this.loadComandos());
    },
    mounted() {
        this.loadComandos();
        this.interval = setInterval(this.loadComandos, 120000);
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },
    methods: {
        async loadComandos() {
            this.contratos = await Contratos.offlines();
        }
    }
};
</script>
